module.exports = __webpack_public_path__ + "static/media/G1-1-Themis-Althea-cod21.16485c9a.png";